import { useMemo } from 'react';
import { Column, Typography } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from "./BillingSection.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetBillingSectionTID = parentTestId => getTestIds({
  parentTestId
});
export const BillingSection = _ref => {
  let {
    title,
    subtitle,
    services,
    hasOptionalServices,
    isOptional,
    testId
  } = _ref;
  const {
    BillingSectionTestIds
  } = useMemo(() => GetBillingSectionTID(testId), [testId]);
  return /*#__PURE__*/_jsxs(Column, {
    className: styles.billingSection,
    "data-testid": BillingSectionTestIds.Root(),
    children: [/*#__PURE__*/_jsxs(Column, {
      className: styles.header,
      children: [hasOptionalServices && !isOptional && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph3",
        skin: "secondary",
        "data-testid": BillingSectionTestIds.StartsAtText(),
        children: "Starts at"
      }), title && /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        "data-testid": BillingSectionTestIds.Title(),
        children: title
      }), subtitle && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        "data-testid": BillingSectionTestIds.Subtitle(),
        children: subtitle
      })]
    }), /*#__PURE__*/_jsx("ul", {
      className: styles.servicesList,
      "data-testid": BillingSectionTestIds.ServicesList(),
      children: services.map(service => {
        const showCheckmark = !isOptional || service.includedByDefault;
        return /*#__PURE__*/_jsxs("li", {
          className: styles.serviceItem,
          "data-testid": BillingSectionTestIds.ServiceItem(service.id),
          children: [showCheckmark ? /*#__PURE__*/_jsx(Checkmark, {
            className: styles.checkIcon,
            "data-testid": BillingSectionTestIds.ServiceCheckmark(service.id)
          }) : /*#__PURE__*/_jsx("span", {
            className: styles.checkIconPlaceholder
          }), /*#__PURE__*/_jsxs(Column, {
            className: styles.serviceContent,
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "paragraph3",
              children: service.name
            }), service.includedServices && service.includedServices.length > 0 && /*#__PURE__*/_jsx("ul", {
              className: styles.includedServicesList,
              children: service.includedServices.map(included => /*#__PURE__*/_jsx("li", {
                "data-testid": BillingSectionTestIds.IncludedServiceItem(included.name),
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph3",
                  skin: "secondary",
                  children: included.name
                })
              }, included.name))
            })]
          })]
        }, service.id);
      })
    })]
  });
};